import { cdataFetch } from "src/api/cdataFetch";

export function updateAccountTOSAcceptance(date: number) {
  return cdataFetch({
    method: "PUT",
    url: `/account/setTosAcceptedDate/${date}`,
  });
}
